/**
 * Single source of truth for QIllustration asset keys and dynamic imports.
 * Web uses `module.default` as image URL; React Native uses Svg components.
 * Migrated from packages/web QIllustrationConfig (relative paths = same files on disk).
 */
export const qIllustrationLoaders = {
  CarAdded: () => import('./CarAdded.svg'),
  FIconnectAll: () => import('./FIconnectAll.svg'),
  FInoneConnected: () => import('./FInoneConnected.svg'),
  FiBuilding: () => import('./FiBuilding.svg'),
  accounts: () => import('./accounts.svg'),
  addDocument: () => import('./addDocument.svg'),
  assetsCoins: () => import('./assetsCoins.svg'),
  attachment: () => import('./attachment.svg'),
  badDate: () => import('./badDate.svg'),
  billConnect: () => import('./billConnect.svg'),
  billConnectStep: () => import('./billConnectStep.svg'),
  billCreditcard: () => import('./billCreditcard.svg'),
  billPresentmentTime: () => import('./billPresentmentTime.svg'),
  billScoutAllSetCashFlow: () => import('./billScoutAllSetCashFlow.svg'),
  billScoutAllSetCashFlowDark: () => import('./billScoutAllSetCashFlowDark.svg'),
  billScoutAllSetReminders: () => import('./billScoutAllSetReminders.svg'),
  billScoutAllSetRemindersDark: () => import('./billScoutAllSetRemindersDark.svg'),
  billScoutAllSetSpendingPlan: () => import('./billScoutAllSetSpendingPlan.svg'),
  billScoutAllSetSpendingPlanDark: () => import('./billScoutAllSetSpendingPlanDark.svg'),
  boxEmpty: () => import('./boxEmpty.svg'),
  boxEmptyDisabled: () => import('./boxEmptyDisabled.svg'),
  businessBilled: () => import('./businessBilled.svg'),
  businessBriefcase: () => import('./businessBriefcase.svg'),
  businessIncomeReceived: () => import('./businessIncomeReceived.svg'),
  businessInvoice: () => import('./businessInvoice.svg'),
  businessProjectsActive: () => import('./businessProjectsActive.svg'),
  businessProjectsCompleted: () => import('./businessProjectsCompleted.svg'),
  businessReadyToBill: () => import('./businessReadyToBill.svg'),
  businessStoreFront: () => import('./businessStoreFront.svg'),
  calendarClock: () => import('./calendarClock.svg'),
  carMeterMiles: () => import('./carMeterMiles.svg'),
  constructionLoan: () => import('./constructionLoan.svg'),
  creditScore: () => import('./creditScore.svg'),
  educationHat: () => import('./educationHat.svg'),
  emailVerificationSuccess: () => import('./emailVerificationSuccess.svg'),
  fiMigrationAccounts: () => import('./fiMigrationAccounts.svg'),
  fiMigrationAccountsDark: () => import('./fiMigrationAccountsDark.svg'),
  fiMigrationAccountsMobile: () => import('./fiMigrationAccountsMobile.svg'),
  fiMigrationAccountsMobileDark: () => import('./fiMigrationAccountsMobileDark.svg'),
  fiMigrationAccountRow: () => import('./fiMigrationAccountRow.svg'),
  fiMigrationAccountRowDark: () => import('./fiMigrationAccountRowDark.svg'),
  fiMigrationBank: () => import('./fiMigrationBank.svg'),
  fiMigrationBankDark: () => import('./fiMigrationBankDark.svg'),
  fiMigrationBankMobile: () => import('./fiMigrationBankMobile.svg'),
  fiMigrationBankMobileDark: () => import('./fiMigrationBankMobileDark.svg'),
  fiMigrationBanner: () => import('./fiMigrationBanner.svg'),
  fiMigrationBannerDark: () => import('./fiMigrationBannerDark.svg'),
  fiMigrationConnection: () => import('./fiMigrationConnection.svg'),
  fiMigrationConnectionDark: () => import('./fiMigrationConnectionDark.svg'),
  fiMigrationDone: () => import('./fiMigrationDone.svg'),
  fiMigrationDoneDark: () => import('./fiMigrationDoneDark.svg'),
  fiMigrationDoneMobile: () => import('./fiMigrationDoneMobile.svg'),
  fiMigrationDoneMobileDark: () => import('./fiMigrationDoneMobileDark.svg'),
  fiMigrationMenu: () => import('./fiMigrationMenu.svg'),
  fiMigrationMenuDark: () => import('./fiMigrationMenuDark.svg'),
  fiMigrationQuicken: () => import('./fiMigrationQuicken.svg'),
  fiMigrationUpdate: () => import('./fiMigrationUpdate.svg'),
  fiMigrationUpdateDark: () => import('./fiMigrationUpdateDark.svg'),
  fiMigrationUpdateCompact: () => import('./fiMigrationUpdateCompact.svg'),
  fourOFour: () => import('./fourOFour.svg'),
  goalSpend: () => import('./goalSpend.svg'),
  goalsCar: () => import('./goalsCar.svg'),
  goalsDebtReduction: () => import('./goalsDebtReduction.svg'),
  goalsHome: () => import('./goalsHome.svg'),
  goalsOther: () => import('./goalsOther.svg'),
  goalsRainyDay: () => import('./goalsRainyDay.svg'),
  goalsVacation: () => import('./goalsVacation.svg'),
  goalsWedding: () => import('./goalsWedding.svg'),
  handsNoice: () => import('./handsNoice.svg'),
  identityVerification: () => import('./identitiyVerification.svg'),
  imageGalleryPreviewDisabled: () => import('./imageGalleryPreviewDisabled.svg'),
  investmentGraph: () => import('./investmentGraph.svg'),
  kbbVehicle: () => import('./kbbVehicle.svg'),
  mailSent: () => import('./mailSent.svg'),
  mapAndPins: () => import('./mapAndPins.svg'),
  militaryLoan: () => import('./militaryLoan.svg'),
  moneyBag: () => import('./moneyBag.svg'),
  moneyFlower: () => import('./moneyFlower.svg'),
  moneyWalletIn: () => import('./moneyWalletIn.svg'),
  netWorth: () => import('./netWorth.svg'),
  newTaxPlanYear: () => import('./newTaxPlanYear.svg'),
  notificationBellOne: () => import('./notificationBellOne.svg'),
  notificationBellTwo: () => import('./notificationBellTwo.svg'),
  phoneVerificationSuccess: () => import('./phoneVerificationSuccess.svg'),
  planeCrash: () => import('./planeCrash.svg'),
  planeFly: () => import('./planeFly.svg'),
  refundWallet: () => import('./refundWallet.svg'),
  reports: () => import('./reports.svg'),
  reportsRecent: () => import('./reportsRecent.svg'),
  reportsSaved: () => import('./reportsSaved.svg'),
  rocketFly: () => import('./rocketFly.svg'),
  rules: () => import('./rules.svg'),
  savingsGoalsNew: () => import('./savingsGoalsNew.svg'),
  searchList: () => import('./searchList.svg'),
  sharingUser: () => import('./sharingUser.svg'),
  spendWallet: () => import('./spendWallet.svg'),
  spendingPlan: () => import('./spendingPlan.svg'),
  spendingPlanBills: () => import('./spendingPlanBills.svg'),
  spendingPlanExcluded: () => import('./spendingPlanExcluded.svg'),
  spendingPlanIncome: () => import('./spendingPlanIncome.svg'),
  spendingPlanIncomplete: () => import('./spendingPlanIncomplete.svg'),
  spendingPlanOther: () => import('./spendingPlanOther.svg'),
  spendingPlanPlanned: () => import('./spendingPlanPlanned.svg'),
  starAmazed: () => import('./starAmazed.svg'),
  starConfused: () => import('./starConfused.svg'),
  starHappy: () => import('./starHappy.svg'),
  starSad: () => import('./starSad.svg'),
  stopWatch: () => import('./StopWatch.svg'),
  successCheck: () => import('./successCheck.svg'),
  successPass: () => import('./sucessPass.svg'),
  taxBusiness: () => import('./taxBusiness.svg'),
  taxCalculator: () => import('./taxCalculator.svg'),
  taxFI: () => import('./taxFI.svg'),
  taxFlag: () => import('./taxFlag.svg'),
  taxPayment: () => import('./taxPayment.svg'),
  taxUser: () => import('./taxUser.svg'),
  textVerificationSuccess: () => import('./textVerificationSuccess.svg'),
  thumbsUp: () => import('./thumbsup.svg'),
  transferCards: () => import('./transferCards.svg'),
  transferSavings: () => import('./transferSavings.svg'),
  transferToAccount: () => import('./transferToAccount.svg'),
  transfers: () => import('./transfers.svg'),
  reviewtransaction: () => import('./reviewtransaction.svg'),
  upcoming: () => import('./upcoming.svg'),
  user: () => import('./user.svg'),
  validationAccount: () => import('./validationAccount.svg'),
  verificationDeposits: () => import('./verificationDeposits.svg'),
  watchlistNew: () => import('./watchlistNew.svg'),
  zillowProperty: () => import('./zillowProperty.svg'),
} as const;

export type QIllustrationName = keyof typeof qIllustrationLoaders;
